import React from "react";
import PropTypes from "prop-types";
import {withNamespaces} from "react-i18next";
import MoneyHelper from "../../../services/MoneyHelper";

const BookingHeaderComponent = (props) => {
  const { t } = props;
  const isTrainerDay = props.eventType === 'training-day';

  const getSubheader = () => {
    if (isTrainerDay) return t('trainer_day_header');
    if (props.isPromotion) return t('booking_promo_subheader');
    if (!props.addon) return t('booking_subheader_free');
    if (props.addon && !props.event) return t('booking_subheader_presale', {price: MoneyHelper.toPrice(props.addon.getTotal())});
    return t('booking_subheader', {price: MoneyHelper.toPrice(props.addon.getTotal())});
  };

  return (
    <div className="booking-header">
      <div className="booking-header-container">
        <h1>
          {getSubheader()}
        </h1>
        <div className="booking-header-blocks">

          {/*{[1, 2, 3].map(item => (*/}
          {/*  <div className='booking-block' key={item}>*/}
          {/*    <img src={`/images/booking/coko-step${item}.${item === 1 ? 'jpg' : 'png'}`} alt={`Step ${item}`} />*/}
          {/*    <h4>{t(`booking_step${item}`)}</h4>*/}
          {/*    <div>*/}
          {/*      <p>{t(`booking_step${item}_text`)}</p>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*))}*/}

        </div>
      </div>
      <hr />
    </div>
  );
};

BookingHeaderComponent.propTypes = {
  addon: PropTypes.object,
};

export default /**/withNamespaces()(BookingHeaderComponent);